(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dose_hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function qs(el, s) { return el.querySelector(s); }
    function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

    var EASE = 'transform 0.55s cubic-bezier(0.22, 0.61, 0.36, 1)';

    function init(root) {
      if (root.__hmDose) return;
      root.__hmDose = true;

      var tabs = qsa(root, '.hm-dose__tab');
      var carousel = qs(root, '[data-hm-carousel]');
      var track = qs(root, '[data-hm-track]');
      var slides = qsa(root, '.hm-dose__slide');
      var bg = qs(root, '[data-hm-bg]');
      var textEl = qs(root, '[data-hm-text]');
      var nameEl = qs(root, '[data-hm-name]');
      var descEl = qs(root, '[data-hm-desc]');
      var shopEl = qs(root, '[data-hm-shop]');
      var dotsWrap = qs(root, '[data-hm-dots]');
      var nd = tabs.length, nf = slides.length;
      if (!nd || !nf) return;

      var dose = 0;
      var flav = parseInt(root.getAttribute('data-start'), 10) || 0;
      if (flav >= nf) flav = 0;

      var dots = [];
      if (dotsWrap) {
        for (var i = 0; i < nf; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'hm-dose__dot'; b.setAttribute('aria-label', 'Flavor ' + (i + 1));
          (function (idx) { b.addEventListener('click', function () { go(idx); }); })(i);
          dotsWrap.appendChild(b); dots.push(b);
        }
      }

      function curSlot() { return parseInt(tabs[dose].getAttribute('data-dose'), 10) || 0; }

      // Centre the active slide. Transition is forced INLINE with !important so a
      // host theme's CSS (or a transition reset) can't turn the slide into a pop.
      function center(animate) {
        var f = slides[flav];
        if (!f) return;
        var x = carousel.clientWidth / 2 - (f.offsetLeft + f.offsetWidth / 2);
        if (animate) {
          track.style.setProperty('transition', EASE, 'important');
          track.style.transform = 'translateX(' + x + 'px)';
        } else {
          track.style.setProperty('transition', 'none', 'important');
          track.style.transform = 'translateX(' + x + 'px)';
          void track.offsetWidth;
          track.style.setProperty('transition', EASE, 'important');
        }
      }

      function paintImages() {
        var slot = curSlot();
        for (var k = 0; k < slides.length; k++) {
          var img = qs(slides[k], '.hm-dose__can');
          var iu = slides[k].getAttribute('data-img-' + slot);
          if (img && iu != null) img.src = iu;
        }
      }
      function paintFocus() {
        for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('is-focus', k === flav);
      }
      function paintContent(animateText) {
        var slot = curSlot(), f = slides[flav];
        if (bg) bg.style.backgroundColor = f.getAttribute('data-bg-' + slot) || '';
        if (textEl) textEl.style.color = f.getAttribute('data-text-' + slot) || '';
        nameEl.textContent = f.getAttribute('data-name') || '';
        descEl.textContent = f.getAttribute('data-desc') || '';
        shopEl.textContent = f.getAttribute('data-btn') || '';
        shopEl.href = f.getAttribute('data-link-' + slot) || '#';
        if (animateText) { textEl.style.animation = 'none'; void textEl.offsetWidth; textEl.style.animation = 'hm-dose-fade .4s ease'; }
        for (var t = 0; t < tabs.length; t++) { tabs[t].classList.toggle('is-active', t === dose); tabs[t].setAttribute('aria-selected', t === dose ? 'true' : 'false'); }
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === flav);
      }

      // Wraps: next past the last flavor returns to the first (slides back), and
      // prev before the first goes to the last.
      function go(i) {
        flav = ((i % nf) + nf) % nf;
        paintImages(); paintFocus(); paintContent(true); center(true);
      }
      function setDose(i) { dose = ((i % nd) + nd) % nd; paintImages(); paintContent(false); }

      tabs.forEach(function (t, i) { t.addEventListener('click', function () { setDose(i); }); });
      slides.forEach(function (s, i) { s.addEventListener('click', function () { if (i !== flav) go(i); }); });
      var prev = qs(root, '[data-hm-prev]'); if (prev) prev.addEventListener('click', function () { go(flav - 1); });
      var next = qs(root, '[data-hm-next]'); if (next) next.addEventListener('click', function () { go(flav + 1); });

      // swipe
      var startX = null;
      carousel.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      carousel.addEventListener('touchend', function (e) {
        if (startX == null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(dx < 0 ? flav + 1 : flav - 1); }
        startX = null;
      }, { passive: true });

      root.addEventListener('keydown', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('hm-dose__tab')) {
          if (e.key === 'ArrowRight') { e.preventDefault(); setDose(dose + 1); tabs[dose].focus(); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); setDose(dose - 1); tabs[dose].focus(); }
        }
      });

      window.addEventListener('resize', function () { center(false); });
      qsa(root, '.hm-dose__can').forEach(function (im) { im.addEventListener('load', function () { center(false); }); });

      paintImages(); paintFocus(); paintContent(false); center(false);
      setTimeout(function () { center(false); }, 80);
      window.addEventListener('load', function () { center(false); });
    }

    function boot() { qsa(document, '[data-hm-dose]').forEach(init); }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);

    // Theme editor re-renders sections without re-running this bundled script,
    // so initialise the freshly loaded section here too.
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target;
      if (!el) return;
      var node = el.querySelector ? el.querySelector('[data-hm-dose]') : null;
      if (node) init(node);
      else if (el.matches && el.matches('[data-hm-dose]')) init(el);
    });
  })();

  /* keyframe injected once */
  (function () {
    if (document.getElementById('hm-dose-kf')) return;
    var st = document.createElement('style'); st.id = 'hm-dose-kf';
    st.textContent = '@keyframes hm-dose-fade{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}';
    document.head.appendChild(st);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education_guide"] && !Shopify.designMode) return;
  try {
    
  // Set the timeline column count from the actual number of onset steps so the
  // desktop rail spaces evenly no matter how many the merchant adds.
  (function () {
    document.querySelectorAll('.hm-edu .hm-timeline').forEach(function (tl) {
      var n = tl.querySelectorAll('.hm-step').length;
      if (n) tl.style.setProperty('--steps', n);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-medium-seltzer-lineup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLineup(root) {
      if (root.dataset.hmLineupReady) return;
      root.dataset.hmLineupReady = 'true';

      var tops = Array.prototype.slice.call(root.querySelectorAll('.hm-flavor__toggle'));
      function equalize() {
        tops.forEach(function (t) { t.style.minHeight = ''; });
        if (window.innerWidth < 750) return;
        var max = 0;
        tops.forEach(function (t) { var h = t.getBoundingClientRect().height; if (h > max) max = h; });
        if (max > 0) tops.forEach(function (t) { t.style.minHeight = Math.ceil(max) + 'px'; });
      }

      // Expand a flavor; close the others (single-open).
      root.addEventListener('click', function (e) {
        var toggle = e.target.closest('.hm-flavor__toggle');
        if (!toggle || !root.contains(toggle)) return;
        e.preventDefault();
        var card = toggle.closest('.hm-flavor');
        var willOpen = !card.classList.contains('is-open');
        root.querySelectorAll('.hm-flavor').forEach(function (c) {
          c.classList.remove('is-open');
          var t = c.querySelector('.hm-flavor__toggle');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          card.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      root.querySelectorAll('.hm-flavor__media img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', equalize, { once: true });
      });
      var raf;
      window.addEventListener('resize', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(equalize);
      });
      equalize();
    }

    function initAll() { document.querySelectorAll('[data-hm-lineup]').forEach(initLineup); }
    if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-hm-lineup]');
      if (root) initLineup(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storelocator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function qs(el, s) { return el.querySelector(s); }
    function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
    function esc(t) {
      return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function haversine(a, b) {
      var R = 3958.8; // miles
      var dLat = (b.lat - a.lat) * Math.PI / 180;
      var dLng = (b.lng - a.lng) * Math.PI / 180;
      var la1 = a.lat * Math.PI / 180, la2 = b.lat * Math.PI / 180;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }

    // All keyless. CARTO's free basemaps now watermark tiles with "API KEY REQUIRED",
    // so the light/colorful styles use Esri's open basemaps instead.
    var TILES = {
      osm:      { url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', sub: 'abc', max: 19, native: 19, attr: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' },
      positron: { url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', sub: '', max: 19, native: 16, attr: 'Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, HERE, Garmin, &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' },
      voyager:  { url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', sub: '', max: 19, native: 19, attr: 'Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, HERE, Garmin, USGS, &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }
    };

    function pinHTML(active) {
      var fill = active ? '#F1B2DC' : '#00A9E0';
      return '<svg viewBox="0 0 40 52" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M20 1C10 1 2 9 2 19c0 13 18 31 18 31s18-18 18-31C38 9 30 1 20 1Z" fill="' + fill + '" stroke="#2D2A26" stroke-width="2.5"/>' +
        '<circle cx="20" cy="19" r="7" fill="#FFFDED" stroke="#2D2A26" stroke-width="2.5"/></svg>';
    }

    function loadLeaflet(cb) {
      if (window.L) { cb(); return; }
      window.__hmLeafletCbs = window.__hmLeafletCbs || [];
      window.__hmLeafletCbs.push(cb);
      if (window.__hmLeafletLoading) return;
      window.__hmLeafletLoading = true;
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);
      var s = document.createElement('script');
      s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      s.async = true;
      s.onload = function () { (window.__hmLeafletCbs || []).forEach(function (f) { f(); }); window.__hmLeafletCbs = []; };
      s.onerror = function () { qsa(document, '[data-hm-locator]').forEach(function (el) { el.classList.add('hm-locator--nomap'); }); };
      document.head.appendChild(s);
    }

    function initLocator(root) {
      if (root.__hmInit) return;
      root.__hmInit = true;

      var canvas = qs(root, '[data-hm-canvas]');
      var listEl = qs(root, '[data-hm-list]');
      var emptyEl = qs(root, '[data-hm-empty]');
      var items = qsa(root, '[data-hm-item]');
      var unit = root.getAttribute('data-unit') || 'mi';

      if (!window.L || !canvas) { root.classList.add('hm-locator--nomap'); return; }

      var tileKey = root.getAttribute('data-tiles') || 'positron';
      var tile = TILES[tileKey] || TILES.positron;

      var map = L.map(canvas, { scrollWheelZoom: false, zoomControl: true })
        .setView([
          parseFloat(root.getAttribute('data-center-lat')) || 35.595,
          parseFloat(root.getAttribute('data-center-lng')) || -82.551
        ], parseInt(root.getAttribute('data-zoom'), 10) || 6);

      L.tileLayer(tile.url, { subdomains: tile.sub, maxZoom: tile.max, maxNativeZoom: tile.native || tile.max, attribution: tile.attr }).addTo(map);
      if (root.getAttribute('data-tint') === 'true') canvas.classList.add('hm-locator__map-canvas--tint');

      // Don't hijack page scroll until the user interacts with the map.
      map.on('focus click', function () { map.scrollWheelZoom.enable(); });
      map.on('mouseout', function () { map.scrollWheelZoom.disable(); });

      var group = L.featureGroup().addTo(map);
      var origin = null, originMarker = null, resolved = 0, total = 0, locked = false, wantNearest = false;

      function icon(active) {
        return L.divIcon({
          className: 'hm-pin' + (active ? ' hm-pin--active' : ''),
          html: pinHTML(active),
          iconSize: [active ? 48 : 40, active ? 62 : 52],
          iconAnchor: [active ? 24 : 20, active ? 62 : 52],
          popupAnchor: [0, active ? -58 : -48]
        });
      }

      var stores = items.map(function (li, i) {
        var la = parseFloat(li.getAttribute('data-lat')), ln = parseFloat(li.getAttribute('data-lng'));
        return {
          li: li, index: i,
          name: li.getAttribute('data-name') || 'Location',
          address: li.getAttribute('data-address') || '',
          tag: li.getAttribute('data-tag') || '',
          phone: li.getAttribute('data-phone') || '',
          website: li.getAttribute('data-website') || '',
          wlabel: li.getAttribute('data-wlabel') || 'Visit',
          position: (isFinite(la) && isFinite(ln)) ? { lat: la, lng: ln } : null,
          marker: null, distance: null
        };
      });
      total = stores.length;

      function fit() {
        if (locked) return; // once the visitor picks a location / uses search, stop auto-fitting
        var layers = group.getLayers();
        if (!layers.length) return;
        map.fitBounds(group.getBounds().pad(0.2));
        if (layers.length === 1) map.setZoom(14);
      }

      function popupHTML(s) {
        var html = '<div class="hm-locator__iw"><p class="hm-locator__iw-name">' + esc(s.name) + '</p>';
        if (window.matchMedia('(max-width: 749px)').matches) {
          // Mobile: the card lives on the Locations tab, so offer a way to open it.
          html += '<button type="button" class="hm-locator__iw-more" data-hm-more>More info &rarr;</button>';
        } else if (s.address) {
          // Desktop: the full card is already beside the map, so just show the address.
          html += '<p class="hm-locator__iw-row">' + esc(s.address) + '</p>';
        }
        return html + '</div>';
      }

      // Open the full location card in the list (and flip to the Locations tab on mobile).
      function openCard(s) {
        if (s.marker) s.marker.closePopup();
        setActive(s);
        if (window.matchMedia('(max-width: 749px)').matches) {
          var r = qs(root, '.hm-locator__vr--list');
          if (r) r.checked = true;
        }
        setTimeout(function () { scrollListTo(s); }, 70);
      }

      function setActive(s) {
        stores.forEach(function (x) {
          x.li.classList.toggle('is-active', x === s);
          if (x.marker) x.marker.setIcon(icon(x === s));
        });
      }

      // Scroll the location list (its own scroll container) to centre a card — without
      // scrolling the whole page, which scrollIntoView tends to do here.
      function scrollListTo(s) {
        var list = qs(root, '.hm-locator__list');
        if (!list || !s.li) return;
        var lr = list.getBoundingClientRect();
        var ir = s.li.getBoundingClientRect();
        var top = list.scrollTop + (ir.top - lr.top) - (list.clientHeight / 2 - s.li.offsetHeight / 2);
        list.scrollTop = Math.max(0, top);
      }

      var FOCUS_ZOOM = 15;
      function select(s) {
        if (!s.position) return;
        locked = true;
        setActive(s);
        scrollListTo(s);
        if (window.matchMedia('(max-width: 749px)').matches) {
          var r = qs(root, '.hm-locator__vr--map');
          if (r) {
            r.checked = true;
            setTimeout(function () { map.invalidateSize(); map.flyTo([s.position.lat, s.position.lng], FOCUS_ZOOM, { duration: 0.5 }); if (s.marker) s.marker.openPopup(); }, 70);
            return;
          }
        }
        map.flyTo([s.position.lat, s.position.lng], FOCUS_ZOOM, { duration: 0.6 });
        if (s.marker) s.marker.openPopup();
      }

      function addMarker(s) {
        if (!s.position) return;
        s.marker = L.marker([s.position.lat, s.position.lng], { icon: icon(false), title: s.name });
        s.marker.bindPopup(function () { return popupHTML(s); }, { autoPanPaddingTopLeft: L.point(14, 74), autoPanPaddingBottomRight: L.point(14, 14) });
        s.marker.on('popupopen', function (e) {
          var el = e.popup.getElement();
          var btn = el && el.querySelector('[data-hm-more]');
          if (!btn) return;
          // L.DomEvent handles touch + stops Leaflet from swallowing the tap.
          L.DomEvent.on(btn, 'click', function (ev) { L.DomEvent.stop(ev); openCard(s); });
        });
        s.marker.on('click', function () { select(s); });
        group.addLayer(s.marker);
        var dir = qs(s.li, '[data-hm-dir]');
        if (dir) dir.href = 'https://www.openstreetmap.org/directions?to=' + s.position.lat + ',' + s.position.lng;
        resolved++;
        if (resolved % 3 === 0 || resolved === total) fit();
        if (origin) {
          computeDistances();
          sortByDistance();
          if (wantNearest) { var n = nearestStore(); if (n) { wantNearest = false; select(n); } }
        }
      }

      function geocode(q, cb) {
        fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(q), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) { cb(d && d[0] ? { lat: parseFloat(d[0].lat), lng: parseFloat(d[0].lon) } : null); })
          .catch(function () { cb(null); });
      }
      // Strip suite/unit noise so the geocoder matches the street, not the suite.
      function cleanForGeo(addr) {
        return addr
          .replace(/\b(ste|suite|unit|apt|bldg)\.?\s*[\w-]+/ig, '')
          .replace(/#\s*[\w-]+/g, '')
          .replace(/\s{2,}/g, ' ').replace(/\s+,/g, ',').trim();
      }
      // Cache each address's coordinates in the browser: geocode once, then instant.
      function readGeoCache(addr) {
        try { var v = localStorage.getItem('hmGeo:' + addr); if (v) { var o = JSON.parse(v); if (o && o.lat != null) return o; } } catch (e) {}
        return null;
      }
      function writeGeoCache(addr, pos) {
        try { localStorage.setItem('hmGeo:' + addr, JSON.stringify(pos)); } catch (e) {}
      }

      // Place every location from its address. Cached results load instantly; the rest
      // are geocoded one-per-second so we stay within Nominatim's usage policy.
      var queue = [];
      stores.forEach(function (s) {
        qs(s.li, '.hm-locator__item-btn').addEventListener('click', function () { select(s); });
        if (s.position) { addMarker(s); return; } // lat/lng supplied — no geocoding needed
        if (!s.address) { resolved++; return; }
        var cached = readGeoCache(s.address);
        if (cached) { s.position = cached; addMarker(s); }
        else { queue.push(s); }
      });
      (function nextGeo() {
        if (!queue.length) { if (resolved >= total) fit(); return; }
        var s = queue.shift();
        geocode(cleanForGeo(s.address), function (pos) {
          if (pos) { s.position = pos; writeGeoCache(s.address, pos); addMarker(s); }
          else { resolved++; if (resolved === total) fit(); }
          setTimeout(nextGeo, 1100);
        });
      })();

      // ----- search -----
      var form = qs(root, '.hm-locator__search');
      var input = qs(root, '.hm-locator__search-input');
      if (form && input) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var q = input.value.trim();
          if (!q) return;
          geocode(q, function (pos) { if (pos) setOrigin(pos); });
        });
      }

      // ----- near me -----
      var nearBtn = qs(root, '.hm-locator__near');
      if (nearBtn && navigator.geolocation) {
        nearBtn.addEventListener('click', function () {
          nearBtn.disabled = true;
          navigator.geolocation.getCurrentPosition(
            function (pos) { nearBtn.disabled = false; setOrigin({ lat: pos.coords.latitude, lng: pos.coords.longitude }, true); },
            function () { nearBtn.disabled = false; }
          );
        });
      } else if (nearBtn) { nearBtn.style.display = 'none'; }

      function setOrigin(pos, focusNearest) {
        origin = pos;
        locked = true;
        if (originMarker) map.removeLayer(originMarker);
        originMarker = L.circleMarker([pos.lat, pos.lng], { radius: 8, color: '#FFFDED', weight: 3, fillColor: '#0057B8', fillOpacity: 1 }).addTo(map);
        computeDistances();
        sortByDistance();
        if (focusNearest) {
          var nearest = nearestStore();
          if (nearest) select(nearest); // go to the closest location, not just the visitor's dot
          else { wantNearest = true; map.setView([pos.lat, pos.lng], Math.max(map.getZoom(), 10)); }
        } else {
          map.setView([pos.lat, pos.lng], Math.max(map.getZoom(), 10));
        }
      }
      function nearestStore() {
        var w = stores.filter(function (s) { return s.distance != null; });
        if (!w.length) return null;
        return w.reduce(function (a, b) { return b.distance < a.distance ? b : a; });
      }

      function computeDistances() {
        stores.forEach(function (s) {
          var distEl = qs(s.li, '[data-hm-dist]');
          if (s.position && origin) {
            var d = haversine(origin, s.position);
            if (unit === 'km') d = d * 1.60934;
            s.distance = d;
            if (distEl) { distEl.hidden = false; distEl.textContent = d.toFixed(1) + ' ' + unit + ' away'; }
          }
        });
      }

      function sortByDistance() {
        stores.slice().sort(function (a, b) {
          if (a.distance == null) return 1;
          if (b.distance == null) return -1;
          return a.distance - b.distance;
        }).forEach(function (s) { listEl.appendChild(s.li); });
      }

      // ----- filter -----
      var filter = qs(root, '.hm-locator__filter');
      if (filter) {
        filter.addEventListener('change', function () {
          var v = filter.value, shown = 0;
          stores.forEach(function (s) {
            var show = !v || s.tag === v;
            s.li.style.display = show ? '' : 'none';
            if (s.marker) { if (show) group.addLayer(s.marker); else group.removeLayer(s.marker); }
            if (show) shown++;
          });
          if (emptyEl) emptyEl.hidden = shown !== 0;
          if (group.getLayers().length) map.fitBounds(group.getBounds().pad(0.2));
        });
      }

      // Re-measure the map when it becomes visible (mobile Map tab).
      var mapRadio = qs(root, '.hm-locator__vr--map');
      if (mapRadio) mapRadio.addEventListener('change', function () {
        if (mapRadio.checked) setTimeout(function () { map.invalidateSize(); fit(); }, 60);
      });
      // Keep the map sized to its cell so tiles always fill it (no background bleed).
      setTimeout(function () { map.invalidateSize(); }, 200);
      window.addEventListener('load', function () { map.invalidateSize(); });
      window.addEventListener('resize', function () { map.invalidateSize(); });
      if (window.ResizeObserver) { new ResizeObserver(function () { map.invalidateSize(); }).observe(canvas); }
    }

    // ---------------------------------------------------------------------
    // CSV location data (optional). Fetched from Content › Files, parsed here,
    // and rendered as the same cards the Liquid blocks produce.
    // ---------------------------------------------------------------------
    function parseCSV(text) {
      var rows = [], row = [], field = '', inQ = false, i = 0, c;
      text = String(text || '').replace(/^﻿/, '');
      while (i < text.length) {
        c = text[i];
        if (inQ) {
          if (c === '"') { if (text[i + 1] === '"') { field += '"'; i++; } else { inQ = false; } }
          else { field += c; }
        } else if (c === '"') { inQ = true; }
        else if (c === ',') { row.push(field); field = ''; }
        else if (c === '\n' || c === '\r') {
          if (c === '\r' && text[i + 1] === '\n') i++;
          row.push(field); field = ''; rows.push(row); row = [];
        } else { field += c; }
        i++;
      }
      if (field !== '' || row.length) { row.push(field); rows.push(row); }
      return rows.filter(function (r) { return r.some(function (v) { return String(v).trim() !== ''; }); });
    }

    var CSV_COLS = {
      name:    ['name', 'storename', 'store', 'location', 'locationname', 'business', 'retailer'],
      address: ['address', 'fulladdress', 'streetaddress', 'location address'],
      street:  ['street', 'street1', 'addressline1', 'address1'],
      city:    ['city', 'town'],
      state:   ['state', 'province', 'region'],
      zip:     ['zip', 'zipcode', 'postalcode', 'postcode'],
      tag:     ['tag', 'category', 'type', 'storetype'],
      phone:   ['phone', 'telephone', 'tel', 'phonenumber'],
      website: ['website', 'url', 'link', 'web', 'site'],
      wlabel:  ['websitelabel', 'linklabel', 'label', 'buttonlabel'],
      lat:     ['lat', 'latitude'],
      lng:     ['lng', 'lon', 'long', 'longitude']
    };
    function csvToStores(rows) {
      if (rows.length < 2) return [];
      var norm = function (h) { return String(h).toLowerCase().replace(/[^a-z0-9]/g, ''); };
      var head = rows[0].map(norm), idx = {};
      Object.keys(CSV_COLS).forEach(function (k) {
        idx[k] = -1;
        CSV_COLS[k].some(function (alias) { var j = head.indexOf(norm(alias)); if (j > -1) { idx[k] = j; return true; } return false; });
      });
      var get = function (r, k) { return idx[k] > -1 && r[idx[k]] != null ? String(r[idx[k]]).trim() : ''; };
      return rows.slice(1).map(function (r) {
        var address = get(r, 'address');
        if (!address) address = [get(r, 'street'), get(r, 'city'), [get(r, 'state'), get(r, 'zip')].filter(Boolean).join(' ')].filter(Boolean).join(', ');
        var web = get(r, 'website');
        if (web && !/^https?:\/\//i.test(web)) web = /^[\w.-]+\.[a-z]{2,}/i.test(web) ? 'https://' + web : '';
        return {
          name: get(r, 'name'), address: address, tag: get(r, 'tag'),
          phone: get(r, 'phone'), website: web, wlabel: get(r, 'wlabel') || 'Visit',
          lat: parseFloat(get(r, 'lat')), lng: parseFloat(get(r, 'lng'))
        };
      }).filter(function (st) { return st.name || st.address; });
    }

    var PIN_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7Zm0 9.6A2.6 2.6 0 1 1 12 6.4a2.6 2.6 0 0 1 0 5.2Z"/></svg>';
    function buildItem(st, index) {
      var li = document.createElement('li');
      li.className = 'hm-locator__item';
      li.setAttribute('data-hm-item', '');
      li.setAttribute('data-index', index);
      li.setAttribute('data-name', st.name || 'Location');
      li.setAttribute('data-address', st.address);
      li.setAttribute('data-tag', st.tag);
      li.setAttribute('data-phone', st.phone);
      li.setAttribute('data-website', st.website);
      li.setAttribute('data-wlabel', st.wlabel);
      if (isFinite(st.lat) && isFinite(st.lng)) { li.setAttribute('data-lat', st.lat); li.setAttribute('data-lng', st.lng); }
      var tel = st.phone.replace(/[\s().-]/g, '');
      li.innerHTML =
        '<button class="hm-locator__item-btn" type="button">' +
          '<span class="hm-locator__item-top">' +
            '<span class="hm-locator__item-pin" aria-hidden="true">' + PIN_SVG + '</span>' +
            '<span class="hm-locator__item-name">' + esc(st.name || 'Location') + '</span>' +
            (st.tag ? '<span class="hm-locator__item-tag">' + esc(st.tag) + '</span>' : '') +
          '</span>' +
          '<span class="hm-locator__item-dist" data-hm-dist hidden></span>' +
          (st.address ? '<span class="hm-locator__item-addr">' + esc(st.address) + '</span>' : '') +
        '</button>' +
        '<span class="hm-locator__item-links">' +
          '<a class="hm-locator__link hm-locator__link--dir" data-hm-dir href="https://www.openstreetmap.org/search?query=' + encodeURIComponent(st.address) + '" target="_blank" rel="noopener">Directions</a>' +
          (st.website ? '<a class="hm-locator__link" href="' + esc(st.website) + '" target="_blank" rel="noopener">' + esc(st.wlabel) + '</a>' : '') +
          (tel ? '<a class="hm-locator__link" href="tel:' + esc(tel) + '">Call</a>' : '') +
        '</span>';
      return li;
    }

    // Rebuild the count line and the category dropdown from whatever is in the list now.
    function refreshMeta(root) {
      var items = qsa(root, '[data-hm-item]');
      var count = qs(root, '[data-hm-count]');
      if (count) count.textContent = items.length + ' ' + (count.getAttribute('data-word') || 'locations');
      var filter = qs(root, '.hm-locator__filter');
      if (!filter) return;
      var tags = [];
      items.forEach(function (li) { var t = li.getAttribute('data-tag'); if (t && tags.indexOf(t) === -1) tags.push(t); });
      while (filter.options.length > 1) filter.remove(1);
      tags.forEach(function (t) { var o = document.createElement('option'); o.value = t; o.textContent = t; filter.appendChild(o); });
      filter.hidden = tags.length === 0;
    }

    function loadStores(root, cb) {
      var url = root.getAttribute('data-csv');
      var listEl = qs(root, '[data-hm-list]');
      if (!url || !listEl) { cb(); return; }
      var count = qs(root, '[data-hm-count]');
      if (count) count.textContent = 'Loading ' + (count.getAttribute('data-word') || 'locations') + '…';
      fetch(url, { cache: 'no-cache' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (text) {
          var stores = csvToStores(parseCSV(text));
          if (!stores.length) throw new Error('No rows with a name or address were found in the CSV.');
          var replace = (root.getAttribute('data-csv-mode') || 'replace') !== 'append';
          if (replace) qsa(listEl, '[data-hm-item]').forEach(function (li) { li.parentNode.removeChild(li); });
          var offset = qsa(listEl, '[data-hm-item]').length;
          stores.forEach(function (st, i) { listEl.appendChild(buildItem(st, offset + i)); });
        })
        .catch(function (err) {
          console.warn('[HM Location Finder] Could not load location CSV (' + url + '): ' + err.message + ' — showing the manual locations instead.');
        })
        .then(function () { refreshMeta(root); cb(); });
    }

    function boot() {
      qsa(document, '[data-hm-locator]').forEach(function (root) {
        // Load Leaflet and the CSV in parallel; build the map once both are in.
        var pending = 2;
        function done() { if (--pending === 0) initLocator(root); }
        loadLeaflet(done);
        loadStores(root, done);
      });
    }

    if (document.querySelector('[data-hm-locator]')) {
      if (document.readyState !== 'loading') boot();
      else document.addEventListener('DOMContentLoaded', boot);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
